import {
    StripeAccount,
    StripeAccountsDetails
} from "@switcherstudio/switcher-api-client";

export enum GatedContentStatus {
    /** Feature is disabled - user does not have claim */
    FEATURE_DISABLED,
    /** User has not setup their Stripe account */
    STRIPE_ACCOUNT_NOT_SETUP,
    /** User has not given their info to Stripe */
    STRIPE_ACCOUNT_UNVERIFIED,
    /** User has submitted their details and can take and receive money */
    READY
}

export interface StripeConnectAccountState {
    gatedContentStatus: GatedContentStatus;
    account: StripeAccount;
    details: StripeAccountsDetails;
    isLoading: boolean;
    isPollingStripeAccounts: boolean;
    startedPollingAt: Date | null;
    pollingTimeout: number;
}
